export function removeResultStatusNotUsed() {
  /**
   * @type {HTMLDivElement}
  */
  const resultStatusNotUsed = document.querySelector('.result-status-unused')
  if (resultStatusNotUsed) {
    resultStatusNotUsed.style.display = 'none'
  }

  const resultStatus = document.querySelector('.result-status')
  if (resultStatus) {
    resultStatus.style.display = 'none'
  }
}

